import script from "./GameRoverDeploy.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameRoverDeploy.vue?vue&type=script&setup=true&lang=ts"

import "./GameRoverDeploy.vue?vue&type=style&index=0&id=8fc1429c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fc1429c"]])

export default __exports__